

/**
 *  @param {Blob} blob
 *  @returns {Promise<String>}
 */
async function fromBlob( blob ) {
	return new Promise( (resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			resolve( reader.result );
		};

		reader.onerror = reject;
		reader.readAsDataURL( blob );
	});
}

/**
 * @param {string} base64_text
 * @returns {Uint8Array}
 */
function parse( base64_text ) {
	return Uint8Array.from( atob( base64_text ), c => c.charCodeAt(0) );
}

function encode( binary ) {
	return btoa( binary );
}

/**
 * @param {string} base64_text
 * @returns {Blob} Blob
 */
function parseURI( data_uri ) {
	const [ prefix, data ] = data_uri.split(',');
	const mime = prefix.split(':')[1].split(';')[0];
	const bytes = parse( data );
	const blob = new Blob( [bytes], { type: mime } );
	return blob;
}

function parseURItoBuffer( data_uri ) {
	const [ prefix, data ] = data_uri.split(',');
	const mime = prefix.split(':')[1].split(';')[0];
	const bytes = parse( data );
	const buffer = Buffer.from( bytes );
	buffer.type = mime;
	buffer.size = buffer.length;
	return buffer;
}

module.exports = {
	fromBlob,
	parse,
	encode,
	parseURI,
	parseURItoBuffer
};